import * as externalServices from './external';
import * as operations from '../generated/operations';
import { servers } from '../generated/servers';
import { requestFunctions } from '../helpers';
import { OperationArgs } from '../store/types';

const dns = {
  production: servers[0],
  qa: servers[1],
  dev: servers[2],
  test: servers[1],
};

const server = dns[process.env.REACT_APP_ENV || process.env.NEXT_PUBLIC_ENV || 'dev'];
const serverFunctions = (operationArgs: OperationArgs) =>
  requestFunctions(server, operationArgs);


const adhocMethods = operations['adhocServiceBuilder'];
const adhoc = {
    actionAdhoc: {
      key: 'adhoc.actionAdhoc',
      method: (operationArgs?: OperationArgs) => adhocMethods(serverFunctions(operationArgs)).actionAdhoc,
    },
};
const auditMethods = operations['auditServiceBuilder'];
const audit = {
    getAudits: {
      key: 'audit.getAudits',
      method: (operationArgs?: OperationArgs) => auditMethods(serverFunctions(operationArgs)).getAudits,
    },
    postAudit: {
      key: 'audit.postAudit',
      method: (operationArgs?: OperationArgs) => auditMethods(serverFunctions(operationArgs)).postAudit,
    },
    getAudit: {
      key: 'audit.getAudit',
      method: (operationArgs?: OperationArgs) => auditMethods(serverFunctions(operationArgs)).getAudit,
    },
};
const authUserMethods = operations['authUserServiceBuilder'];
const authUser = {
    me: {
      key: 'authUser.me',
      method: (operationArgs?: OperationArgs) => authUserMethods(serverFunctions(operationArgs)).me,
    },
    postMe: {
      key: 'authUser.postMe',
      method: (operationArgs?: OperationArgs) => authUserMethods(serverFunctions(operationArgs)).postMe,
    },
    putMe: {
      key: 'authUser.putMe',
      method: (operationArgs?: OperationArgs) => authUserMethods(serverFunctions(operationArgs)).putMe,
    },
};
const companyMethods = operations['companyServiceBuilder'];
const company = {
    getCompanies: {
      key: 'company.getCompanies',
      method: (operationArgs?: OperationArgs) => companyMethods(serverFunctions(operationArgs)).getCompanies,
    },
    postCompany: {
      key: 'company.postCompany',
      method: (operationArgs?: OperationArgs) => companyMethods(serverFunctions(operationArgs)).postCompany,
    },
    getCompany: {
      key: 'company.getCompany',
      method: (operationArgs?: OperationArgs) => companyMethods(serverFunctions(operationArgs)).getCompany,
    },
    putCompany: {
      key: 'company.putCompany',
      method: (operationArgs?: OperationArgs) => companyMethods(serverFunctions(operationArgs)).putCompany,
    },
    deleteCompany: {
      key: 'company.deleteCompany',
      method: (operationArgs?: OperationArgs) => companyMethods(serverFunctions(operationArgs)).deleteCompany,
    },
    postCompanyBilling: {
      key: 'company.postCompanyBilling',
      method: (operationArgs?: OperationArgs) => companyMethods(serverFunctions(operationArgs)).postCompanyBilling,
    },
    postCompanyBillingSuccess: {
      key: 'company.postCompanyBillingSuccess',
      method: (operationArgs?: OperationArgs) => companyMethods(serverFunctions(operationArgs)).postCompanyBillingSuccess,
    },
    getCompanyDirectorVerification: {
      key: 'company.getCompanyDirectorVerification',
      method: (operationArgs?: OperationArgs) => companyMethods(serverFunctions(operationArgs)).getCompanyDirectorVerification,
    },
    postCompanyDirectorVerification: {
      key: 'company.postCompanyDirectorVerification',
      method: (operationArgs?: OperationArgs) => companyMethods(serverFunctions(operationArgs)).postCompanyDirectorVerification,
    },
    directorCompany: {
      key: 'company.directorCompany',
      method: (operationArgs?: OperationArgs) => companyMethods(serverFunctions(operationArgs)).directorCompany,
    },
    getCompanyReferrals: {
      key: 'company.getCompanyReferrals',
      method: (operationArgs?: OperationArgs) => companyMethods(serverFunctions(operationArgs)).getCompanyReferrals,
    },
    postCompanyReferrals: {
      key: 'company.postCompanyReferrals',
      method: (operationArgs?: OperationArgs) => companyMethods(serverFunctions(operationArgs)).postCompanyReferrals,
    },
    approveCompany: {
      key: 'company.approveCompany',
      method: (operationArgs?: OperationArgs) => companyMethods(serverFunctions(operationArgs)).approveCompany,
    },
    declineCompany: {
      key: 'company.declineCompany',
      method: (operationArgs?: OperationArgs) => companyMethods(serverFunctions(operationArgs)).declineCompany,
    },
    exportFcaApproved: {
      key: 'company.exportFcaApproved',
      method: (operationArgs?: OperationArgs) => companyMethods(serverFunctions(operationArgs)).exportFcaApproved,
    },
    importFcaApproved: {
      key: 'company.importFcaApproved',
      method: (operationArgs?: OperationArgs) => companyMethods(serverFunctions(operationArgs)).importFcaApproved,
    },
};
const creditMethods = operations['creditServiceBuilder'];
const credit = {
    infoCredit: {
      key: 'credit.infoCredit',
      method: (operationArgs?: OperationArgs) => creditMethods(serverFunctions(operationArgs)).infoCredit,
    },
    getCredits: {
      key: 'credit.getCredits',
      method: (operationArgs?: OperationArgs) => creditMethods(serverFunctions(operationArgs)).getCredits,
    },
    postCredit: {
      key: 'credit.postCredit',
      method: (operationArgs?: OperationArgs) => creditMethods(serverFunctions(operationArgs)).postCredit,
    },
    getCredit: {
      key: 'credit.getCredit',
      method: (operationArgs?: OperationArgs) => creditMethods(serverFunctions(operationArgs)).getCredit,
    },
    putCredit: {
      key: 'credit.putCredit',
      method: (operationArgs?: OperationArgs) => creditMethods(serverFunctions(operationArgs)).putCredit,
    },
    deleteCredit: {
      key: 'credit.deleteCredit',
      method: (operationArgs?: OperationArgs) => creditMethods(serverFunctions(operationArgs)).deleteCredit,
    },
    quoteCredit: {
      key: 'credit.quoteCredit',
      method: (operationArgs?: OperationArgs) => creditMethods(serverFunctions(operationArgs)).quoteCredit,
    },
    applyCredit: {
      key: 'credit.applyCredit',
      method: (operationArgs?: OperationArgs) => creditMethods(serverFunctions(operationArgs)).applyCredit,
    },
    checkCredit: {
      key: 'credit.checkCredit',
      method: (operationArgs?: OperationArgs) => creditMethods(serverFunctions(operationArgs)).checkCredit,
    },
    signCredit: {
      key: 'credit.signCredit',
      method: (operationArgs?: OperationArgs) => creditMethods(serverFunctions(operationArgs)).signCredit,
    },
    migrateCredit: {
      key: 'credit.migrateCredit',
      method: (operationArgs?: OperationArgs) => creditMethods(serverFunctions(operationArgs)).migrateCredit,
    },
    consentMigrateCredit: {
      key: 'credit.consentMigrateCredit',
      method: (operationArgs?: OperationArgs) => creditMethods(serverFunctions(operationArgs)).consentMigrateCredit,
    },
};
const documentMethods = operations['documentServiceBuilder'];
const document = {
    getDocuments: {
      key: 'document.getDocuments',
      method: (operationArgs?: OperationArgs) => documentMethods(serverFunctions(operationArgs)).getDocuments,
    },
    postDocument: {
      key: 'document.postDocument',
      method: (operationArgs?: OperationArgs) => documentMethods(serverFunctions(operationArgs)).postDocument,
    },
    getDocument: {
      key: 'document.getDocument',
      method: (operationArgs?: OperationArgs) => documentMethods(serverFunctions(operationArgs)).getDocument,
    },
    putDocument: {
      key: 'document.putDocument',
      method: (operationArgs?: OperationArgs) => documentMethods(serverFunctions(operationArgs)).putDocument,
    },
    deleteDocument: {
      key: 'document.deleteDocument',
      method: (operationArgs?: OperationArgs) => documentMethods(serverFunctions(operationArgs)).deleteDocument,
    },
};
const enquiryMethods = operations['enquiryServiceBuilder'];
const enquiry = {
    getEnquiries: {
      key: 'enquiry.getEnquiries',
      method: (operationArgs?: OperationArgs) => enquiryMethods(serverFunctions(operationArgs)).getEnquiries,
    },
    postEnquiry: {
      key: 'enquiry.postEnquiry',
      method: (operationArgs?: OperationArgs) => enquiryMethods(serverFunctions(operationArgs)).postEnquiry,
    },
    getEnquiry: {
      key: 'enquiry.getEnquiry',
      method: (operationArgs?: OperationArgs) => enquiryMethods(serverFunctions(operationArgs)).getEnquiry,
    },
    putEnquiry: {
      key: 'enquiry.putEnquiry',
      method: (operationArgs?: OperationArgs) => enquiryMethods(serverFunctions(operationArgs)).putEnquiry,
    },
    deleteEnquiry: {
      key: 'enquiry.deleteEnquiry',
      method: (operationArgs?: OperationArgs) => enquiryMethods(serverFunctions(operationArgs)).deleteEnquiry,
    },
    postEnquiryConsumer: {
      key: 'enquiry.postEnquiryConsumer',
      method: (operationArgs?: OperationArgs) => enquiryMethods(serverFunctions(operationArgs)).postEnquiryConsumer,
    },
    postEnquiryConsumerSignature: {
      key: 'enquiry.postEnquiryConsumerSignature',
      method: (operationArgs?: OperationArgs) => enquiryMethods(serverFunctions(operationArgs)).postEnquiryConsumerSignature,
    },
    postEnquiryConsumerPreferences: {
      key: 'enquiry.postEnquiryConsumerPreferences',
      method: (operationArgs?: OperationArgs) => enquiryMethods(serverFunctions(operationArgs)).postEnquiryConsumerPreferences,
    },
    postEnquiryQuote: {
      key: 'enquiry.postEnquiryQuote',
      method: (operationArgs?: OperationArgs) => enquiryMethods(serverFunctions(operationArgs)).postEnquiryQuote,
    },
    postEnquiryJobInfo: {
      key: 'enquiry.postEnquiryJobInfo',
      method: (operationArgs?: OperationArgs) => enquiryMethods(serverFunctions(operationArgs)).postEnquiryJobInfo,
    },
    postEnquiryInterestInCredit: {
      key: 'enquiry.postEnquiryInterestInCredit',
      method: (operationArgs?: OperationArgs) => enquiryMethods(serverFunctions(operationArgs)).postEnquiryInterestInCredit,
    },
    postEnquiryBudget: {
      key: 'enquiry.postEnquiryBudget',
      method: (operationArgs?: OperationArgs) => enquiryMethods(serverFunctions(operationArgs)).postEnquiryBudget,
    },
    postEnquirySubmit: {
      key: 'enquiry.postEnquirySubmit',
      method: (operationArgs?: OperationArgs) => enquiryMethods(serverFunctions(operationArgs)).postEnquirySubmit,
    },
    postEnquiryState: {
      key: 'enquiry.postEnquiryState',
      method: (operationArgs?: OperationArgs) => enquiryMethods(serverFunctions(operationArgs)).postEnquiryState,
    },
    postEnquiryConvertJob: {
      key: 'enquiry.postEnquiryConvertJob',
      method: (operationArgs?: OperationArgs) => enquiryMethods(serverFunctions(operationArgs)).postEnquiryConvertJob,
    },
    postEnquiryArchive: {
      key: 'enquiry.postEnquiryArchive',
      method: (operationArgs?: OperationArgs) => enquiryMethods(serverFunctions(operationArgs)).postEnquiryArchive,
    },
    postEnquiryUnarchive: {
      key: 'enquiry.postEnquiryUnarchive',
      method: (operationArgs?: OperationArgs) => enquiryMethods(serverFunctions(operationArgs)).postEnquiryUnarchive,
    },
};
const enrolmentMethods = operations['enrolmentServiceBuilder'];
const enrolment = {
    getEnrolments: {
      key: 'enrolment.getEnrolments',
      method: (operationArgs?: OperationArgs) => enrolmentMethods(serverFunctions(operationArgs)).getEnrolments,
    },
    getEnrolment: {
      key: 'enrolment.getEnrolment',
      method: (operationArgs?: OperationArgs) => enrolmentMethods(serverFunctions(operationArgs)).getEnrolment,
    },
    putEnrolment: {
      key: 'enrolment.putEnrolment',
      method: (operationArgs?: OperationArgs) => enrolmentMethods(serverFunctions(operationArgs)).putEnrolment,
    },
};
const enterpriseMethods = operations['enterpriseServiceBuilder'];
const enterprise = {
    getEnterprises: {
      key: 'enterprise.getEnterprises',
      method: (operationArgs?: OperationArgs) => enterpriseMethods(serverFunctions(operationArgs)).getEnterprises,
    },
    postEnterprise: {
      key: 'enterprise.postEnterprise',
      method: (operationArgs?: OperationArgs) => enterpriseMethods(serverFunctions(operationArgs)).postEnterprise,
    },
    getEnterprise: {
      key: 'enterprise.getEnterprise',
      method: (operationArgs?: OperationArgs) => enterpriseMethods(serverFunctions(operationArgs)).getEnterprise,
    },
    putEnterprise: {
      key: 'enterprise.putEnterprise',
      method: (operationArgs?: OperationArgs) => enterpriseMethods(serverFunctions(operationArgs)).putEnterprise,
    },
    deleteEnterprise: {
      key: 'enterprise.deleteEnterprise',
      method: (operationArgs?: OperationArgs) => enterpriseMethods(serverFunctions(operationArgs)).deleteEnterprise,
    },
    getEnterpriseBranches: {
      key: 'enterprise.getEnterpriseBranches',
      method: (operationArgs?: OperationArgs) => enterpriseMethods(serverFunctions(operationArgs)).getEnterpriseBranches,
    },
    postEnterpriseBranches: {
      key: 'enterprise.postEnterpriseBranches',
      method: (operationArgs?: OperationArgs) => enterpriseMethods(serverFunctions(operationArgs)).postEnterpriseBranches,
    },
    exportEnterpriseDailyReport: {
      key: 'enterprise.exportEnterpriseDailyReport',
      method: (operationArgs?: OperationArgs) => enterpriseMethods(serverFunctions(operationArgs)).exportEnterpriseDailyReport,
    },
};
const eventMethods = operations['eventServiceBuilder'];
const event = {
    postEvent: {
      key: 'event.postEvent',
      method: (operationArgs?: OperationArgs) => eventMethods(serverFunctions(operationArgs)).postEvent,
    },
};
const infoAuthMethods = operations['infoAuthServiceBuilder'];
const infoAuth = {
    infoAuth: {
      key: 'infoAuth.infoAuth',
      method: (operationArgs?: OperationArgs) => infoAuthMethods(serverFunctions(operationArgs)).infoAuth,
    },
    infoVerify: {
      key: 'infoAuth.infoVerify',
      method: (operationArgs?: OperationArgs) => infoAuthMethods(serverFunctions(operationArgs)).infoVerify,
    },
    infoPassword: {
      key: 'infoAuth.infoPassword',
      method: (operationArgs?: OperationArgs) => infoAuthMethods(serverFunctions(operationArgs)).infoPassword,
    },
    infoSession: {
      key: 'infoAuth.infoSession',
      method: (operationArgs?: OperationArgs) => infoAuthMethods(serverFunctions(operationArgs)).infoSession,
    },
    infoClaimAccount: {
      key: 'infoAuth.infoClaimAccount',
      method: (operationArgs?: OperationArgs) => infoAuthMethods(serverFunctions(operationArgs)).infoClaimAccount,
    },
};
const infoCacheMethods = operations['infoCacheServiceBuilder'];
const infoCache = {
    infoGetCache: {
      key: 'infoCache.infoGetCache',
      method: (operationArgs?: OperationArgs) => infoCacheMethods(serverFunctions(operationArgs)).infoGetCache,
    },
    infoPutCache: {
      key: 'infoCache.infoPutCache',
      method: (operationArgs?: OperationArgs) => infoCacheMethods(serverFunctions(operationArgs)).infoPutCache,
    },
    infoDeleteCache: {
      key: 'infoCache.infoDeleteCache',
      method: (operationArgs?: OperationArgs) => infoCacheMethods(serverFunctions(operationArgs)).infoDeleteCache,
    },
};
const infoCampaignMethods = operations['infoCampaignServiceBuilder'];
const infoCampaign = {
    infoCampaign: {
      key: 'infoCampaign.infoCampaign',
      method: (operationArgs?: OperationArgs) => infoCampaignMethods(serverFunctions(operationArgs)).infoCampaign,
    },
};
const infoCompanyMethods = operations['infoCompanyServiceBuilder'];
const infoCompany = {
    infoCompany: {
      key: 'infoCompany.infoCompany',
      method: (operationArgs?: OperationArgs) => infoCompanyMethods(serverFunctions(operationArgs)).infoCompany,
    },
};
const infoCustomerMethods = operations['infoCustomerServiceBuilder'];
const infoCustomer = {
    infoCustomer: {
      key: 'infoCustomer.infoCustomer',
      method: (operationArgs?: OperationArgs) => infoCustomerMethods(serverFunctions(operationArgs)).infoCustomer,
    },
};
const infoDirectorMethods = operations['infoDirectorServiceBuilder'];
const infoDirector = {
    infoDirector: {
      key: 'infoDirector.infoDirector',
      method: (operationArgs?: OperationArgs) => infoDirectorMethods(serverFunctions(operationArgs)).infoDirector,
    },
};
const infoEnquiryMethods = operations['infoEnquiryServiceBuilder'];
const infoEnquiry = {
    getInfoEnquiry: {
      key: 'infoEnquiry.getInfoEnquiry',
      method: (operationArgs?: OperationArgs) => infoEnquiryMethods(serverFunctions(operationArgs)).getInfoEnquiry,
    },
};
const infoEnterpriseRoleMethods = operations['infoEnterpriseRoleServiceBuilder'];
const infoEnterpriseRole = {
    infoEnterpriseRole: {
      key: 'infoEnterpriseRole.infoEnterpriseRole',
      method: (operationArgs?: OperationArgs) => infoEnterpriseRoleMethods(serverFunctions(operationArgs)).infoEnterpriseRole,
    },
};
const infoEnterpriseMethods = operations['infoEnterpriseServiceBuilder'];
const infoEnterprise = {
    infoEnterprise: {
      key: 'infoEnterprise.infoEnterprise',
      method: (operationArgs?: OperationArgs) => infoEnterpriseMethods(serverFunctions(operationArgs)).infoEnterprise,
    },
};
const infoEntityMethods = operations['infoEntityServiceBuilder'];
const infoEntity = {
    getInfoEntity: {
      key: 'infoEntity.getInfoEntity',
      method: (operationArgs?: OperationArgs) => infoEntityMethods(serverFunctions(operationArgs)).getInfoEntity,
    },
};
const infoGhostMethods = operations['infoGhostServiceBuilder'];
const infoGhost = {
    infoGhost: {
      key: 'infoGhost.infoGhost',
      method: (operationArgs?: OperationArgs) => infoGhostMethods(serverFunctions(operationArgs)).infoGhost,
    },
};
const infoHealthMethods = operations['infoHealthServiceBuilder'];
const infoHealth = {
    infoHealth: {
      key: 'infoHealth.infoHealth',
      method: (operationArgs?: OperationArgs) => infoHealthMethods(serverFunctions(operationArgs)).infoHealth,
    },
};
const infoIPMethods = operations['infoIPServiceBuilder'];
const infoIP = {
    infoIP: {
      key: 'infoIP.infoIP',
      method: (operationArgs?: OperationArgs) => infoIPMethods(serverFunctions(operationArgs)).infoIP,
    },
};
const infoIntroductionStatsMethods = operations['infoIntroductionStatsServiceBuilder'];
const infoIntroductionStats = {
    infoIntroductionStats: {
      key: 'infoIntroductionStats.infoIntroductionStats',
      method: (operationArgs?: OperationArgs) => infoIntroductionStatsMethods(serverFunctions(operationArgs)).infoIntroductionStats,
    },
};
const infoLeadMethods = operations['infoLeadServiceBuilder'];
const infoLead = {
    infoLead: {
      key: 'infoLead.infoLead',
      method: (operationArgs?: OperationArgs) => infoLeadMethods(serverFunctions(operationArgs)).infoLead,
    },
};
const infoOnboardingMethods = operations['infoOnboardingServiceBuilder'];
const infoOnboarding = {
    infoOnboarding: {
      key: 'infoOnboarding.infoOnboarding',
      method: (operationArgs?: OperationArgs) => infoOnboardingMethods(serverFunctions(operationArgs)).infoOnboarding,
    },
};
const infoPartnerMethods = operations['infoPartnerServiceBuilder'];
const infoPartner = {
    infoPartnerBranding: {
      key: 'infoPartner.infoPartnerBranding',
      method: (operationArgs?: OperationArgs) => infoPartnerMethods(serverFunctions(operationArgs)).infoPartnerBranding,
    },
};
const infoQueryMethods = operations['infoQueryServiceBuilder'];
const infoQuery = {
    infoQuery: {
      key: 'infoQuery.infoQuery',
      method: (operationArgs?: OperationArgs) => infoQueryMethods(serverFunctions(operationArgs)).infoQuery,
    },
};
const infoRedirectMethods = operations['infoRedirectServiceBuilder'];
const infoRedirect = {
    infoLegacyRedirect: {
      key: 'infoRedirect.infoLegacyRedirect',
      method: (operationArgs?: OperationArgs) => infoRedirectMethods(serverFunctions(operationArgs)).infoLegacyRedirect,
    },
    infoCheckoutRedirect: {
      key: 'infoRedirect.infoCheckoutRedirect',
      method: (operationArgs?: OperationArgs) => infoRedirectMethods(serverFunctions(operationArgs)).infoCheckoutRedirect,
    },
};
const infoRelationMethods = operations['infoRelationServiceBuilder'];
const infoRelation = {
    infoRelation: {
      key: 'infoRelation.infoRelation',
      method: (operationArgs?: OperationArgs) => infoRelationMethods(serverFunctions(operationArgs)).infoRelation,
    },
};
const infoSearchMethods = operations['infoSearchServiceBuilder'];
const infoSearch = {
    infoSearch: {
      key: 'infoSearch.infoSearch',
      method: (operationArgs?: OperationArgs) => infoSearchMethods(serverFunctions(operationArgs)).infoSearch,
    },
};
const infoStatsMethods = operations['infoStatsServiceBuilder'];
const infoStats = {
    infoStats: {
      key: 'infoStats.infoStats',
      method: (operationArgs?: OperationArgs) => infoStatsMethods(serverFunctions(operationArgs)).infoStats,
    },
    putInfoStats: {
      key: 'infoStats.putInfoStats',
      method: (operationArgs?: OperationArgs) => infoStatsMethods(serverFunctions(operationArgs)).putInfoStats,
    },
};
const infoTagMethods = operations['infoTagServiceBuilder'];
const infoTag = {
    putInfoTag: {
      key: 'infoTag.putInfoTag',
      method: (operationArgs?: OperationArgs) => infoTagMethods(serverFunctions(operationArgs)).putInfoTag,
    },
};
const infoValidationMethods = operations['infoValidationServiceBuilder'];
const infoValidation = {
    infoValidateEmail: {
      key: 'infoValidation.infoValidateEmail',
      method: (operationArgs?: OperationArgs) => infoValidationMethods(serverFunctions(operationArgs)).infoValidateEmail,
    },
};
const infoWorkTypeMethods = operations['infoWorkTypeServiceBuilder'];
const infoWorkType = {
    infoWorkType: {
      key: 'infoWorkType.infoWorkType',
      method: (operationArgs?: OperationArgs) => infoWorkTypeMethods(serverFunctions(operationArgs)).infoWorkType,
    },
};
const introductionMethods = operations['introductionServiceBuilder'];
const introduction = {
    getIntroductions: {
      key: 'introduction.getIntroductions',
      method: (operationArgs?: OperationArgs) => introductionMethods(serverFunctions(operationArgs)).getIntroductions,
    },
    postIntroduction: {
      key: 'introduction.postIntroduction',
      method: (operationArgs?: OperationArgs) => introductionMethods(serverFunctions(operationArgs)).postIntroduction,
    },
    getIntroduction: {
      key: 'introduction.getIntroduction',
      method: (operationArgs?: OperationArgs) => introductionMethods(serverFunctions(operationArgs)).getIntroduction,
    },
    putIntroduction: {
      key: 'introduction.putIntroduction',
      method: (operationArgs?: OperationArgs) => introductionMethods(serverFunctions(operationArgs)).putIntroduction,
    },
    deleteIntroduction: {
      key: 'introduction.deleteIntroduction',
      method: (operationArgs?: OperationArgs) => introductionMethods(serverFunctions(operationArgs)).deleteIntroduction,
    },
    postIntroductionConsumerSignature: {
      key: 'introduction.postIntroductionConsumerSignature',
      method: (operationArgs?: OperationArgs) => introductionMethods(serverFunctions(operationArgs)).postIntroductionConsumerSignature,
    },
    postIntroductionConsumerDetails: {
      key: 'introduction.postIntroductionConsumerDetails',
      method: (operationArgs?: OperationArgs) => introductionMethods(serverFunctions(operationArgs)).postIntroductionConsumerDetails,
    },
    postIntroductionConsumerBudgets: {
      key: 'introduction.postIntroductionConsumerBudgets',
      method: (operationArgs?: OperationArgs) => introductionMethods(serverFunctions(operationArgs)).postIntroductionConsumerBudgets,
    },
    postIntroductionConsumerApply: {
      key: 'introduction.postIntroductionConsumerApply',
      method: (operationArgs?: OperationArgs) => introductionMethods(serverFunctions(operationArgs)).postIntroductionConsumerApply,
    },
    postIntroductionJobDetails: {
      key: 'introduction.postIntroductionJobDetails',
      method: (operationArgs?: OperationArgs) => introductionMethods(serverFunctions(operationArgs)).postIntroductionJobDetails,
    },
    postIntroductionAmendJobDetails: {
      key: 'introduction.postIntroductionAmendJobDetails',
      method: (operationArgs?: OperationArgs) => introductionMethods(serverFunctions(operationArgs)).postIntroductionAmendJobDetails,
    },
    postIntroductionTrader: {
      key: 'introduction.postIntroductionTrader',
      method: (operationArgs?: OperationArgs) => introductionMethods(serverFunctions(operationArgs)).postIntroductionTrader,
    },
    postIntroductionTraderSignature: {
      key: 'introduction.postIntroductionTraderSignature',
      method: (operationArgs?: OperationArgs) => introductionMethods(serverFunctions(operationArgs)).postIntroductionTraderSignature,
    },
    postIntroductionTraderApproveAmended: {
      key: 'introduction.postIntroductionTraderApproveAmended',
      method: (operationArgs?: OperationArgs) => introductionMethods(serverFunctions(operationArgs)).postIntroductionTraderApproveAmended,
    },
    postIntroductionTraderDetails: {
      key: 'introduction.postIntroductionTraderDetails',
      method: (operationArgs?: OperationArgs) => introductionMethods(serverFunctions(operationArgs)).postIntroductionTraderDetails,
    },
    postIntroductionRejectJob: {
      key: 'introduction.postIntroductionRejectJob',
      method: (operationArgs?: OperationArgs) => introductionMethods(serverFunctions(operationArgs)).postIntroductionRejectJob,
    },
    submitIntroductionState: {
      key: 'introduction.submitIntroductionState',
      method: (operationArgs?: OperationArgs) => introductionMethods(serverFunctions(operationArgs)).submitIntroductionState,
    },
    postIntroductionConvertJob: {
      key: 'introduction.postIntroductionConvertJob',
      method: (operationArgs?: OperationArgs) => introductionMethods(serverFunctions(operationArgs)).postIntroductionConvertJob,
    },
    postIntroductionNotification: {
      key: 'introduction.postIntroductionNotification',
      method: (operationArgs?: OperationArgs) => introductionMethods(serverFunctions(operationArgs)).postIntroductionNotification,
    },
    actionIntroduction: {
      key: 'introduction.actionIntroduction',
      method: (operationArgs?: OperationArgs) => introductionMethods(serverFunctions(operationArgs)).actionIntroduction,
    },
};
const jobMethods = operations['jobServiceBuilder'];
const job = {
    infoExampleJob: {
      key: 'job.infoExampleJob',
      method: (operationArgs?: OperationArgs) => jobMethods(serverFunctions(operationArgs)).infoExampleJob,
    },
    getJobs: {
      key: 'job.getJobs',
      method: (operationArgs?: OperationArgs) => jobMethods(serverFunctions(operationArgs)).getJobs,
    },
    postJob: {
      key: 'job.postJob',
      method: (operationArgs?: OperationArgs) => jobMethods(serverFunctions(operationArgs)).postJob,
    },
    getJob: {
      key: 'job.getJob',
      method: (operationArgs?: OperationArgs) => jobMethods(serverFunctions(operationArgs)).getJob,
    },
    putJob: {
      key: 'job.putJob',
      method: (operationArgs?: OperationArgs) => jobMethods(serverFunctions(operationArgs)).putJob,
    },
    deleteJob: {
      key: 'job.deleteJob',
      method: (operationArgs?: OperationArgs) => jobMethods(serverFunctions(operationArgs)).deleteJob,
    },
    sendJob: {
      key: 'job.sendJob',
      method: (operationArgs?: OperationArgs) => jobMethods(serverFunctions(operationArgs)).sendJob,
    },
    resendJob: {
      key: 'job.resendJob',
      method: (operationArgs?: OperationArgs) => jobMethods(serverFunctions(operationArgs)).resendJob,
    },
    checkJob: {
      key: 'job.checkJob',
      method: (operationArgs?: OperationArgs) => jobMethods(serverFunctions(operationArgs)).checkJob,
    },
    completeJob: {
      key: 'job.completeJob',
      method: (operationArgs?: OperationArgs) => jobMethods(serverFunctions(operationArgs)).completeJob,
    },
    archiveJob: {
      key: 'job.archiveJob',
      method: (operationArgs?: OperationArgs) => jobMethods(serverFunctions(operationArgs)).archiveJob,
    },
    unarchiveJob: {
      key: 'job.unarchiveJob',
      method: (operationArgs?: OperationArgs) => jobMethods(serverFunctions(operationArgs)).unarchiveJob,
    },
    quoteJob: {
      key: 'job.quoteJob',
      method: (operationArgs?: OperationArgs) => jobMethods(serverFunctions(operationArgs)).quoteJob,
    },
    applyJob: {
      key: 'job.applyJob',
      method: (operationArgs?: OperationArgs) => jobMethods(serverFunctions(operationArgs)).applyJob,
    },
    reapplyJob: {
      key: 'job.reapplyJob',
      method: (operationArgs?: OperationArgs) => jobMethods(serverFunctions(operationArgs)).reapplyJob,
    },
    payJob: {
      key: 'job.payJob',
      method: (operationArgs?: OperationArgs) => jobMethods(serverFunctions(operationArgs)).payJob,
    },
    viewJobSatNote: {
      key: 'job.viewJobSatNote',
      method: (operationArgs?: OperationArgs) => jobMethods(serverFunctions(operationArgs)).viewJobSatNote,
    },
    signJobSatNote: {
      key: 'job.signJobSatNote',
      method: (operationArgs?: OperationArgs) => jobMethods(serverFunctions(operationArgs)).signJobSatNote,
    },
    approveJobSatNote: {
      key: 'job.approveJobSatNote',
      method: (operationArgs?: OperationArgs) => jobMethods(serverFunctions(operationArgs)).approveJobSatNote,
    },
    lenderReviewJobSatNote: {
      key: 'job.lenderReviewJobSatNote',
      method: (operationArgs?: OperationArgs) => jobMethods(serverFunctions(operationArgs)).lenderReviewJobSatNote,
    },
    delayJobSatNote: {
      key: 'job.delayJobSatNote',
      method: (operationArgs?: OperationArgs) => jobMethods(serverFunctions(operationArgs)).delayJobSatNote,
    },
    payoutJob: {
      key: 'job.payoutJob',
      method: (operationArgs?: OperationArgs) => jobMethods(serverFunctions(operationArgs)).payoutJob,
    },
    payoutsJob: {
      key: 'job.payoutsJob',
      method: (operationArgs?: OperationArgs) => jobMethods(serverFunctions(operationArgs)).payoutsJob,
    },
    overrideJob: {
      key: 'job.overrideJob',
      method: (operationArgs?: OperationArgs) => jobMethods(serverFunctions(operationArgs)).overrideJob,
    },
    jobCheckoutLink: {
      key: 'job.jobCheckoutLink',
      method: (operationArgs?: OperationArgs) => jobMethods(serverFunctions(operationArgs)).jobCheckoutLink,
    },
    jobCompanyInfo: {
      key: 'job.jobCompanyInfo',
      method: (operationArgs?: OperationArgs) => jobMethods(serverFunctions(operationArgs)).jobCompanyInfo,
    },
    exportJobPayouts: {
      key: 'job.exportJobPayouts',
      method: (operationArgs?: OperationArgs) => jobMethods(serverFunctions(operationArgs)).exportJobPayouts,
    },
};
const leadMethods = operations['leadServiceBuilder'];
const lead = {
    getLeads: {
      key: 'lead.getLeads',
      method: (operationArgs?: OperationArgs) => leadMethods(serverFunctions(operationArgs)).getLeads,
    },
    postLead: {
      key: 'lead.postLead',
      method: (operationArgs?: OperationArgs) => leadMethods(serverFunctions(operationArgs)).postLead,
    },
    getLead: {
      key: 'lead.getLead',
      method: (operationArgs?: OperationArgs) => leadMethods(serverFunctions(operationArgs)).getLead,
    },
    putLead: {
      key: 'lead.putLead',
      method: (operationArgs?: OperationArgs) => leadMethods(serverFunctions(operationArgs)).putLead,
    },
    deleteLead: {
      key: 'lead.deleteLead',
      method: (operationArgs?: OperationArgs) => leadMethods(serverFunctions(operationArgs)).deleteLead,
    },
    applyInviteLead: {
      key: 'lead.applyInviteLead',
      method: (operationArgs?: OperationArgs) => leadMethods(serverFunctions(operationArgs)).applyInviteLead,
    },
    budgetLead: {
      key: 'lead.budgetLead',
      method: (operationArgs?: OperationArgs) => leadMethods(serverFunctions(operationArgs)).budgetLead,
    },
    quoteLead: {
      key: 'lead.quoteLead',
      method: (operationArgs?: OperationArgs) => leadMethods(serverFunctions(operationArgs)).quoteLead,
    },
    sendLeadJob: {
      key: 'lead.sendLeadJob',
      method: (operationArgs?: OperationArgs) => leadMethods(serverFunctions(operationArgs)).sendLeadJob,
    },
    tradeLead: {
      key: 'lead.tradeLead',
      method: (operationArgs?: OperationArgs) => leadMethods(serverFunctions(operationArgs)).tradeLead,
    },
    tradeQuoteApprovalLead: {
      key: 'lead.tradeQuoteApprovalLead',
      method: (operationArgs?: OperationArgs) => leadMethods(serverFunctions(operationArgs)).tradeQuoteApprovalLead,
    },
    matchTradesLead: {
      key: 'lead.matchTradesLead',
      method: (operationArgs?: OperationArgs) => leadMethods(serverFunctions(operationArgs)).matchTradesLead,
    },
    connectTradesLead: {
      key: 'lead.connectTradesLead',
      method: (operationArgs?: OperationArgs) => leadMethods(serverFunctions(operationArgs)).connectTradesLead,
    },
    acceptedJobSummaryLead: {
      key: 'lead.acceptedJobSummaryLead',
      method: (operationArgs?: OperationArgs) => leadMethods(serverFunctions(operationArgs)).acceptedJobSummaryLead,
    },
    referLead: {
      key: 'lead.referLead',
      method: (operationArgs?: OperationArgs) => leadMethods(serverFunctions(operationArgs)).referLead,
    },
};
const monitorMethods = operations['monitorServiceBuilder'];
const monitor = {
    getMonitors: {
      key: 'monitor.getMonitors',
      method: (operationArgs?: OperationArgs) => monitorMethods(serverFunctions(operationArgs)).getMonitors,
    },
    postMonitor: {
      key: 'monitor.postMonitor',
      method: (operationArgs?: OperationArgs) => monitorMethods(serverFunctions(operationArgs)).postMonitor,
    },
    getMonitor: {
      key: 'monitor.getMonitor',
      method: (operationArgs?: OperationArgs) => monitorMethods(serverFunctions(operationArgs)).getMonitor,
    },
    putMonitor: {
      key: 'monitor.putMonitor',
      method: (operationArgs?: OperationArgs) => monitorMethods(serverFunctions(operationArgs)).putMonitor,
    },
    deleteMonitor: {
      key: 'monitor.deleteMonitor',
      method: (operationArgs?: OperationArgs) => monitorMethods(serverFunctions(operationArgs)).deleteMonitor,
    },
    postMonitorFlag: {
      key: 'monitor.postMonitorFlag',
      method: (operationArgs?: OperationArgs) => monitorMethods(serverFunctions(operationArgs)).postMonitorFlag,
    },
};
const onboardingMethods = operations['onboardingServiceBuilder'];
const onboarding = {
    getOnboardings: {
      key: 'onboarding.getOnboardings',
      method: (operationArgs?: OperationArgs) => onboardingMethods(serverFunctions(operationArgs)).getOnboardings,
    },
    postOnboarding: {
      key: 'onboarding.postOnboarding',
      method: (operationArgs?: OperationArgs) => onboardingMethods(serverFunctions(operationArgs)).postOnboarding,
    },
    getOnboarding: {
      key: 'onboarding.getOnboarding',
      method: (operationArgs?: OperationArgs) => onboardingMethods(serverFunctions(operationArgs)).getOnboarding,
    },
    putOnboarding: {
      key: 'onboarding.putOnboarding',
      method: (operationArgs?: OperationArgs) => onboardingMethods(serverFunctions(operationArgs)).putOnboarding,
    },
    deleteOnboarding: {
      key: 'onboarding.deleteOnboarding',
      method: (operationArgs?: OperationArgs) => onboardingMethods(serverFunctions(operationArgs)).deleteOnboarding,
    },
    postOnboardingDecision: {
      key: 'onboarding.postOnboardingDecision',
      method: (operationArgs?: OperationArgs) => onboardingMethods(serverFunctions(operationArgs)).postOnboardingDecision,
    },
};
const partnerMethods = operations['partnerServiceBuilder'];
const partner = {
    getPartners: {
      key: 'partner.getPartners',
      method: (operationArgs?: OperationArgs) => partnerMethods(serverFunctions(operationArgs)).getPartners,
    },
    postPartner: {
      key: 'partner.postPartner',
      method: (operationArgs?: OperationArgs) => partnerMethods(serverFunctions(operationArgs)).postPartner,
    },
    getPartner: {
      key: 'partner.getPartner',
      method: (operationArgs?: OperationArgs) => partnerMethods(serverFunctions(operationArgs)).getPartner,
    },
    putPartner: {
      key: 'partner.putPartner',
      method: (operationArgs?: OperationArgs) => partnerMethods(serverFunctions(operationArgs)).putPartner,
    },
    deletePartner: {
      key: 'partner.deletePartner',
      method: (operationArgs?: OperationArgs) => partnerMethods(serverFunctions(operationArgs)).deletePartner,
    },
    postPartnerReferrals: {
      key: 'partner.postPartnerReferrals',
      method: (operationArgs?: OperationArgs) => partnerMethods(serverFunctions(operationArgs)).postPartnerReferrals,
    },
};
const paymentMethods = operations['paymentServiceBuilder'];
const payment = {
    getPayments: {
      key: 'payment.getPayments',
      method: (operationArgs?: OperationArgs) => paymentMethods(serverFunctions(operationArgs)).getPayments,
    },
    postPayment: {
      key: 'payment.postPayment',
      method: (operationArgs?: OperationArgs) => paymentMethods(serverFunctions(operationArgs)).postPayment,
    },
    getPayment: {
      key: 'payment.getPayment',
      method: (operationArgs?: OperationArgs) => paymentMethods(serverFunctions(operationArgs)).getPayment,
    },
    putPayment: {
      key: 'payment.putPayment',
      method: (operationArgs?: OperationArgs) => paymentMethods(serverFunctions(operationArgs)).putPayment,
    },
    deletePayment: {
      key: 'payment.deletePayment',
      method: (operationArgs?: OperationArgs) => paymentMethods(serverFunctions(operationArgs)).deletePayment,
    },
    markPayment: {
      key: 'payment.markPayment',
      method: (operationArgs?: OperationArgs) => paymentMethods(serverFunctions(operationArgs)).markPayment,
    },
};
const rateMethods = operations['rateServiceBuilder'];
const rate = {
    infoRate: {
      key: 'rate.infoRate',
      method: (operationArgs?: OperationArgs) => rateMethods(serverFunctions(operationArgs)).infoRate,
    },
    getRates: {
      key: 'rate.getRates',
      method: (operationArgs?: OperationArgs) => rateMethods(serverFunctions(operationArgs)).getRates,
    },
    postRate: {
      key: 'rate.postRate',
      method: (operationArgs?: OperationArgs) => rateMethods(serverFunctions(operationArgs)).postRate,
    },
    getRate: {
      key: 'rate.getRate',
      method: (operationArgs?: OperationArgs) => rateMethods(serverFunctions(operationArgs)).getRate,
    },
    putRate: {
      key: 'rate.putRate',
      method: (operationArgs?: OperationArgs) => rateMethods(serverFunctions(operationArgs)).putRate,
    },
    deleteRate: {
      key: 'rate.deleteRate',
      method: (operationArgs?: OperationArgs) => rateMethods(serverFunctions(operationArgs)).deleteRate,
    },
};
const subscriptionMethods = operations['subscriptionServiceBuilder'];
const subscription = {
    getSubscriptions: {
      key: 'subscription.getSubscriptions',
      method: (operationArgs?: OperationArgs) => subscriptionMethods(serverFunctions(operationArgs)).getSubscriptions,
    },
    postSubscription: {
      key: 'subscription.postSubscription',
      method: (operationArgs?: OperationArgs) => subscriptionMethods(serverFunctions(operationArgs)).postSubscription,
    },
    getSubscription: {
      key: 'subscription.getSubscription',
      method: (operationArgs?: OperationArgs) => subscriptionMethods(serverFunctions(operationArgs)).getSubscription,
    },
    putSubscription: {
      key: 'subscription.putSubscription',
      method: (operationArgs?: OperationArgs) => subscriptionMethods(serverFunctions(operationArgs)).putSubscription,
    },
    deleteSubscription: {
      key: 'subscription.deleteSubscription',
      method: (operationArgs?: OperationArgs) => subscriptionMethods(serverFunctions(operationArgs)).deleteSubscription,
    },
    pendingSubscription: {
      key: 'subscription.pendingSubscription',
      method: (operationArgs?: OperationArgs) => subscriptionMethods(serverFunctions(operationArgs)).pendingSubscription,
    },
};
const tagMethods = operations['tagServiceBuilder'];
const tag = {
    getTags: {
      key: 'tag.getTags',
      method: (operationArgs?: OperationArgs) => tagMethods(serverFunctions(operationArgs)).getTags,
    },
    postTag: {
      key: 'tag.postTag',
      method: (operationArgs?: OperationArgs) => tagMethods(serverFunctions(operationArgs)).postTag,
    },
    getTag: {
      key: 'tag.getTag',
      method: (operationArgs?: OperationArgs) => tagMethods(serverFunctions(operationArgs)).getTag,
    },
    putTag: {
      key: 'tag.putTag',
      method: (operationArgs?: OperationArgs) => tagMethods(serverFunctions(operationArgs)).putTag,
    },
    deleteTag: {
      key: 'tag.deleteTag',
      method: (operationArgs?: OperationArgs) => tagMethods(serverFunctions(operationArgs)).deleteTag,
    },
};
const taskMethods = operations['taskServiceBuilder'];
const task = {
    runner: {
      key: 'task.runner',
      method: (operationArgs?: OperationArgs) => taskMethods(serverFunctions(operationArgs)).runner,
    },
};
const tradeSummaryMethods = operations['tradeSummaryServiceBuilder'];
const tradeSummary = {
    infoTradeSummary: {
      key: 'tradeSummary.infoTradeSummary',
      method: (operationArgs?: OperationArgs) => tradeSummaryMethods(serverFunctions(operationArgs)).infoTradeSummary,
    },
};
const trainingMethods = operations['trainingServiceBuilder'];
const training = {
    getTrainings: {
      key: 'training.getTrainings',
      method: (operationArgs?: OperationArgs) => trainingMethods(serverFunctions(operationArgs)).getTrainings,
    },
    postTraining: {
      key: 'training.postTraining',
      method: (operationArgs?: OperationArgs) => trainingMethods(serverFunctions(operationArgs)).postTraining,
    },
    getTraining: {
      key: 'training.getTraining',
      method: (operationArgs?: OperationArgs) => trainingMethods(serverFunctions(operationArgs)).getTraining,
    },
    putTraining: {
      key: 'training.putTraining',
      method: (operationArgs?: OperationArgs) => trainingMethods(serverFunctions(operationArgs)).putTraining,
    },
    deleteTraining: {
      key: 'training.deleteTraining',
      method: (operationArgs?: OperationArgs) => trainingMethods(serverFunctions(operationArgs)).deleteTraining,
    },
};
const transactionMethods = operations['transactionServiceBuilder'];
const transaction = {
    getTransactions: {
      key: 'transaction.getTransactions',
      method: (operationArgs?: OperationArgs) => transactionMethods(serverFunctions(operationArgs)).getTransactions,
    },
    postTransaction: {
      key: 'transaction.postTransaction',
      method: (operationArgs?: OperationArgs) => transactionMethods(serverFunctions(operationArgs)).postTransaction,
    },
    getTransaction: {
      key: 'transaction.getTransaction',
      method: (operationArgs?: OperationArgs) => transactionMethods(serverFunctions(operationArgs)).getTransaction,
    },
    putTransaction: {
      key: 'transaction.putTransaction',
      method: (operationArgs?: OperationArgs) => transactionMethods(serverFunctions(operationArgs)).putTransaction,
    },
    deleteTransaction: {
      key: 'transaction.deleteTransaction',
      method: (operationArgs?: OperationArgs) => transactionMethods(serverFunctions(operationArgs)).deleteTransaction,
    },
};
const webhookMethods = operations['webhookServiceBuilder'];
const webhook = {
    providerCheckWebhook: {
      key: 'webhook.providerCheckWebhook',
      method: (operationArgs?: OperationArgs) => webhookMethods(serverFunctions(operationArgs)).providerCheckWebhook,
    },
    providerWebhook: {
      key: 'webhook.providerWebhook',
      method: (operationArgs?: OperationArgs) => webhookMethods(serverFunctions(operationArgs)).providerWebhook,
    },
};

const address = externalServices['address'];
const contract = externalServices['contract'];
const payouts = externalServices['payouts'];
const pdf = externalServices['pdf'];
const personalGuarantee = externalServices['personalGuarantee'];
const sheets = externalServices['sheets'];
const subsSheet = externalServices['subsSheet'];

/**
 * A list of all possible services the frontend can use.
 */
const services = {
  adhoc,
  audit,
  authUser,
  company,
  credit,
  document,
  enquiry,
  enrolment,
  enterprise,
  event,
  infoAuth,
  infoCache,
  infoCampaign,
  infoCompany,
  infoCustomer,
  infoDirector,
  infoEnquiry,
  infoEnterpriseRole,
  infoEnterprise,
  infoEntity,
  infoGhost,
  infoHealth,
  infoIP,
  infoIntroductionStats,
  infoLead,
  infoOnboarding,
  infoPartner,
  infoQuery,
  infoRedirect,
  infoRelation,
  infoSearch,
  infoStats,
  infoTag,
  infoValidation,
  infoWorkType,
  introduction,
  job,
  lead,
  monitor,
  onboarding,
  partner,
  payment,
  rate,
  subscription,
  tag,
  task,
  tradeSummary,
  training,
  transaction,
  webhook,
  address,
  contract,
  payouts,
  pdf,
  personalGuarantee,
  sheets,
  subsSheet,

};

export {
  adhoc,
  audit,
  authUser,
  company,
  credit,
  document,
  enquiry,
  enrolment,
  enterprise,
  event,
  infoAuth,
  infoCache,
  infoCampaign,
  infoCompany,
  infoCustomer,
  infoDirector,
  infoEnquiry,
  infoEnterpriseRole,
  infoEnterprise,
  infoEntity,
  infoGhost,
  infoHealth,
  infoIP,
  infoIntroductionStats,
  infoLead,
  infoOnboarding,
  infoPartner,
  infoQuery,
  infoRedirect,
  infoRelation,
  infoSearch,
  infoStats,
  infoTag,
  infoValidation,
  infoWorkType,
  introduction,
  job,
  lead,
  monitor,
  onboarding,
  partner,
  payment,
  rate,
  subscription,
  tag,
  task,
  tradeSummary,
  training,
  transaction,
  webhook,
  address,
  contract,
  payouts,
  pdf,
  personalGuarantee,
  sheets,
  subsSheet,

};

export default services;